export default "__VITE_ASSET__DSH$fMax__"